import React from 'react';
import { useNavigate } from 'react-router-dom';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import particlesConfig from '../Shared/pr-s-black';
import '../Assets/Stylesheets/Pages/Affiliate.scss';

import AffiliateImg1 from '../Assets/Images/Affiliate_img1.png';
import AffiliateImg2 from '../Assets/Images/Affiliate_img2.png';
import AffiliateImg3 from '../Assets/Images/Affiliate_img3.png';
import AffiliateImg4 from '../Assets/Images/Affiliate_img4.png';

export default function Affiliate() {
  const navigate = useNavigate();

  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  const benefits = [
    {
      id: 1,
      title: 'Passive Income',
      description: 'Earn by simply referring clients to us. The more successful referrals you make, the more you earn.',
      image: AffiliateImg2,
      icon: '💰'
    },
    {
      id: 2,
      title: 'No Client Management',
      description: 'Focus solely on referrals. There\'s no need to manage client relationships or deliverables. We take care of all the post-referral processes.',
      image: AffiliateImg3,
      icon: '🎯'
    },
    {
      id: 3,
      title: 'Access to Marketing Materials',
      description: 'We provide you with all the marketing materials you need to effectively promote TRND Marketplace.',
      image: AffiliateImg4,
      icon: '📊'
    }
  ];

  const steps = [
    {
      number: 1,
      title: 'Sign Up and Get Your Referral Link',
      description: 'Joining is straightforward. Once you sign up, you\'ll receive a unique referral link or ID.'
    },
    {
      number: 2,
      title: 'Share and Promote',
      description: 'Use your link to introduce TRND Marketplace to your network. Whether it\'s through social media, email, or your website, how you share is up to you.'
    },
    {
      number: 3,
      title: 'Earn Commissions',
      description: 'For every client that signs up through your link and purchases a service, you receive a commission.'
    }
  ];

  const handleApplyClick = () => {
    navigate('/contact');
  };

  return (
    <div id="affiliate-page">
      {/* Coming-soon notice: the referral/MRA portal is not yet available. */}
      <div
        role="status"
        style={{
          background: '#7a5c00',
          color: '#fff',
          padding: '10px 16px',
          textAlign: 'center',
          fontSize: 14,
          fontFamily: '"Poppins", sans-serif',
        }}
      >
        Our referral partner program is coming soon. Sign-ups are not open yet —
        check back shortly.
      </div>
      {/* Hero Section */}
      <section className="affiliate-hero">
        <div className="particles circle-bg">
          <div className="container">
            <div className="title-box">
              <h6>REFERRAL PARTNER PROGRAM</h6>
              <h1>
                <span className="color-font">Turn Your Network</span>
              </h1>
              <h1>
                into Your <span className="color-font">Net Worth</span>
              </h1>
              <p className="hero-subtitle">Welcome to Your Next Opportunity</p>
              <button className="apply-button" onClick={handleApplyClick}>
                APPLY NOW
              </button>
            </div>
          </div>

          <Particles
            id="particles-js"
            init={particlesInit}
            options={particlesConfig}
          />

          <div className="gradient-circle"></div>
          <div className="gradient-circle two"></div>
        </div>
      </section>

      {/* Why Join Section */}
      <section className="why-join-section">
        <div className="container">
          <h2><span className="color-font">Why Join</span> as a Referral Partner?</h2>
          <div className="why-join-content">
            <p>Welcome to TRND Marketplace's Referral Partner Program — an exciting avenue for those who want to leverage their network and earn by connecting businesses with our cutting-edge digital marketing solutions.</p>
            <p>As a Referral Partner, or what many would traditionally understand as an affiliate, you play a crucial role in our ecosystem by bridging the gap between potential clients and our comprehensive suite of marketing services.</p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2><span className="color-font">Key Benefits</span> for Partners</h2>
          <div className="benefits-grid">
            {benefits.map((benefit) => (
              <div key={benefit.id} className="benefit-card">
                <div className="benefit-image">
                  <img src={benefit.image} alt={benefit.title} />
                </div>
                <div className="benefit-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works-section">
        <div className="container">
          <h2>How It Works: <span className="color-font">Simple, Seamless, Rewarding</span></h2>
          <div className="steps-container">
            {steps.map((step) => (
              <div key={step.number} className="step-card">
                <div className="step-number">{step.number}</div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Expectations & Rewards Section */}
      <section className="rewards-section">
        <div className="container">
          <div className="rewards-content">
            <div className="rewards-text">
              <h2><span className="color-font">Expectations</span> and Rewards</h2>
              <p>As a TRND Marketplace Referral Partner, your potential is unlimited. Commissions are competitive, giving you a lucrative opportunity to earn based on the volume and quality of your referrals.</p>
              <p>Detailed terms, including commission rates and payment schedules, will be provided upon joining the program.</p>
            </div>
            <div className="rewards-image">
              <img src={AffiliateImg1} alt="Rewards" />
            </div>
          </div>
        </div>
      </section>

      {/* Future of Marketing Section */}
      <section className="future-section">
        <div className="container">
          <div className="future-content">
            <div className="future-image">
              <img src={AffiliateImg1} alt="Future of Marketing" />
            </div>
            <div className="future-text">
              <h2>Become Part of the <span className="color-font">Future of Marketing</span></h2>
              <p>Ready to turn your network into your net worth? Joining TRND Marketplace as a Referral Partner is not just about earning commissions — it's about being at the forefront of the digital marketing revolution and contributing to the success stories of businesses worldwide.</p>
              <button className="apply-button" onClick={handleApplyClick}>
                JOIN NOW
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}